module.exports = __webpack_public_path__ + "video/200_PAB_2021_BeAHero.a901363f.vtt";